import { RefObject, useEffect, useState } from 'react';

export const SMALL_MAX_WIDTH = 360;

export type WidthVariant = 'large' | 'small';

/** Returns 'small' when the observed element width is ≤ 360px, else 'large'. Container-driven, not viewport. */
export const useFieldWidthBreakpoint = (ref: RefObject<HTMLElement>): WidthVariant => {
  const [variant, setVariant] = useState<WidthVariant>('large');

  useEffect(() => {
    const el = ref.current;
    if (!el || typeof ResizeObserver === 'undefined') return;
    const update = (width: number) => setVariant(width <= SMALL_MAX_WIDTH ? 'small' : 'large');
    update(el.getBoundingClientRect().width);
    const observer = new ResizeObserver((entries) => {
      const width = entries[0]?.contentRect.width ?? el.getBoundingClientRect().width;
      update(width);
    });
    observer.observe(el);
    return () => observer.disconnect();
  }, [ref]);

  return variant;
};
